import { ElMessage } from 'element-plus'
import FormulaUtil from './FormulaUtil'
import { isNullOrUnDef, isNullOrUndefOrEmpty, isNumber } from '@/utils/is'
import Big from 'big.js'
// 通过公式计算出结果
export function getCalFormulaValue(formula: string, formModel?: Recordable) {
  let verity = true
  verity = validateFormula(formula)
  if (!verity) {
    // 如果公式为空或者字符串符号没有成对输入
    return false
  }
  // 传入了表单值
  if (formModel) {
    const reg = /\{(\w+)\}/ // 主要用于匹配字符串中以大括号 {} 包裹的连续的字母、数字或下划线
    // 全局去匹配，字符串，只要匹配到就会执行一次回调
    // 也就是说公式中有字段才会匹配成功，才会执行回调
    formula = formula.replace(new RegExp(reg, 'g'), replacer => {
      const match = replacer.match(new RegExp(reg))
      if (match) {
        // 匹配传入的表单数据，再根据传入的字段配置取拿值，然后将字段替换成值
        const value = formModel[match[1]]
        // 没有输入值或值为0
        if (isNullOrUndefOrEmpty(value)) {
          return undefined
        }
        if (typeof value === 'number') {
          return value || 0
        } else if (typeof value === 'string') {
          return Number(value) || 0
        }
        return value
      } else {
        return ''
      }
    })
    // if (!verity) {
    //   return false
    // }
  }
  // 这儿得到的就是根据表单的数据，将公式中对应的字段变成表单对应的值，或者就是表单输入的值，或者混合值
  const d = formula.split(/(\$[0-9a-zA-Z._]+#[0-9A-Fa-f]*)/g)
  const e: string[] = []
  let v = ''
  d.forEach((n: string) => e.push(n))
  try {
    v = evalFormula(formatFormula(e.join('')))
  } catch (e) {
    v = ''
  }
  return isNullOrUnDef(v) ? '' : v
}

/**
 * 缓存
 */
const evalFormulaMemoize = () => {
  const b: any = []
  Object.keys(FormulaUtil).forEach(n => {
    b.push('var ' + n + '=FormulaUtil.' + n)
  })
  return b.join(';') + ';'
}
/**
 * 获取eval 执行后结果
 * @returns
 */
export function getEvalFormula() {
  return evalFormulaMemoize()
}

export function evalFormula(a: string) {
  let c = null
  let env = null
  try {
    env = getEvalFormula()
    console.log(env + 'return ' + a + ';')
    c = new Function(env + 'return ' + a + ';')()
  } catch (e) {
    // 实际上是通过真正的计算来判断公式是否有误，所以左侧的所有可选字段都给一个初始的值用于计算公式对不对
    ElMessage.error('执行公式有误，请检查公式格式')
    console.error(e)
    c = null
  }
  return c
}

// 公式校验
function validateFormula(formula: string): boolean {
  const result = true
  // 空值
  if (!formula || formula.length === 0) {
    ElMessage.error('请输入公式')
    return false
  }

  if (!isCloseBrackets(formula)) {
    ElMessage.error('在字符串符号是否成对输入')
    return false
  }
  return result
}

/**
 * 判断符号是否闭合
 * @param params
 * @param keyCollection
 * @returns
 */
function isCloseBrackets(
  params: string,
  keyCollection = [
    ['{', '}'],
    ['[', ']'],
    ['(', ')'],
    ['<', '>']
  ]
) {
  const array = params.split('')
  // 过滤掉不符合要求的单括号
  keyCollection = keyCollection.filter(item => Array.isArray(item) && item.length === 2)
  if (!array.length || !keyCollection.length) return
  const keyObj: any = {}
  const stack = []
  const leftKey = []
  const rightKey = []
  for (let i = 0; i < keyCollection.length; i++) {
    const [left, right] = keyCollection[i]
    const index = i
    keyObj[left] = index + 1
    keyObj[right] = -(index + 1)
    leftKey.push(left)
    rightKey.push(right)
  }
  for (let index = 0; index < array.length; index++) {
    const element = array[index]
    if (keyObj.hasOwnProperty(element) && leftKey.includes(element)) {
      stack.push(keyObj[element])
    } else if (keyObj.hasOwnProperty(element) && rightKey.includes(element)) {
      const currentKeyObj = keyObj[element]
      const currentLength = stack.length
      if (currentLength > 0 && stack[currentLength - 1] + currentKeyObj === 0) {
        stack.pop()
      } else {
        stack.push(currentKeyObj)
      }
    }
  }
  return stack.length === 0
}
/**
 * 数组拍平
 * @param ary
 * @param predicate
 * @param result
 * @returns
 */
export function flatten(ary: Array<number>, predicate?: Function, result?: Array<any>) {
  result = result || []
  if (ary) {
    for (let i = 0; i < ary.length; i++) {
      const value = ary[i]
      if (Array.isArray(value)) {
        flatten(value, predicate, result)
      } else {
        ;(predicate && !predicate(value)) || result.push(value)
      }
    }
  }
  return result
}
/**
 * 表达式执行器
 * @param op
 * @param left
 * @param right
 * @returns
 */
export function evalExpression(op: string, left: number, right: number) {
  const calcOps = ['+', '-', '*', '/']
  let result: any
  if (op === '!') {
    return window.eval(op + 'left')
  }
  if (calcOps.indexOf(op) > -1 && isNumber(left) && isNumber(right)) {
    switch (op) {
      case '+':
        result = new Big(left).plus(right)
        break
      case '-':
        result = new Big(left).minus(right)
        break
      case '*':
        result = new Big(left).times(right)
        break
      case '/':
        result = right === 0 ? '' : new Big(left).div(right)
    }
    return result === '' ? null : Number(result.toString())
  }
  return window.eval('left' + op + 'right')
}

// 运算表达式规则处理
function formatFormula(formula: string) {
  let str = ''
  if (formula.indexOf('AVERAGE') > -1) {
    str = formula.replaceAll('undefined,', '')
    str = str.replaceAll('undefined', '')
    str = str.indexOf('()') > -1 ? '' : str
  } else if (formula.indexOf('SUM') > -1) {
    str = formula.replaceAll('undefined', '0')
    return str
  } else {
    str = formula.replaceAll('undefined', '0')
    // 分母为0就不计算  第一个参数为空就不计算
    if ((str.indexOf('/0') > -1 && str.indexOf('/0.') === -1) || !/^[0-9](.*)$/.test(str)) {
      return ''
    }
  }
  return str
}
